import React, { useEffect, useRef, useState } from "react";

import useTranslation from "next-translate/useTranslation";
import styles from "./styles/Lobby.module.css";
import LobbyPopups from "./popups/LobbyPopups";
import Head from "next/head";
import {
  useLobby,
  enterLobby,
  // exitLobby,
  showChallengePopup,
  chooseGame,
  setTab,
} from "../../redux/lobby";
import {
  ChessSets,
  CREATE_GAME_TAB,
  DAILY_GAMES_TAB,
  DAILY_TAB,
  LIVE_GAME_TAB,
  // CREATE_GAME_TAB,
  // DAILY_TAB,
  // LIVE_GAME_TAB,
  ModeIds,
  TimeControl,
  VARIANT_CHESS,
} from "@chesshotel/constants";
import { getModeId } from "../../util/util";
// import {  } from "../ducks/lobby";
import { REGULAR_TIER, UNLIMITED_TIER } from "@chesshotel/constants";
// import { getModeId } from "../../util/util";
import LobbyBody from "./LobbyBody";
import PlayWire from "../../components/common/play-wire";
import {
  ADS_PROVIDER_YANDEX,
  ADS_PROVIDER_PLAYWIRE,
  ADS_PROVIDER_GAM,
  ADS_PROVIDER_ADSENSE,
  useSiteData,
} from "../../redux/siteData";
import { useMembership } from "../../redux/membership";
import AdSense from "../../components/common/ad-sense";
import { useRouter } from "next/router";
import ChallengePopup from "../challenge/ChallengePopup";
import CustomGamePopup from "./popups/CustomGamePopup";
import LobbyHead from "./LobbyHead";
import CreateGame from "./CreateGame";
import { setSetting, useSettings } from "@/redux/settings";
import {
  preloadChessImages,
  getPieceImageUrls,
} from "../../util/imagePreloader";
import boardStyles from "../../chessBoard/components/Board.module.css";
import { useSignIn } from "@/redux/signIn";
import { useWsConnection } from "@/redux/wsConnection";
import ChessSetPopup from "./popups/ChessSetPopup";
import { shouldCountPlaywirePageview } from "@/lib/playwire";

function initLobbyChosenGame(isDesktop: boolean, tab: number) {
  try {
    const timeVal = localStorage.getItem("chosenTime");
    const incVal = localStorage.getItem("chosenInc");
    const variantVal = localStorage.getItem("chosenVariant");
    const turnLengthVal = localStorage.getItem("turnLength");
    const timeControlVal = localStorage.getItem("timeControl");

    const time = timeVal ? parseInt(timeVal) : 10;
    const inc = incVal ? parseInt(incVal) : 0;
    const variant = variantVal ? parseInt(variantVal) : VARIANT_CHESS;
    const timeControl = timeControlVal
      ? parseInt(timeControlVal)
      : TimeControl.LIVE;
    const turnLength = turnLengthVal ? parseInt(turnLengthVal) : 2;

    if (timeControl == TimeControl.LIVE) {
      if (typeof window !== "undefined") {
        if (tab !== DAILY_GAMES_TAB) {
          if (isDesktop) {
            setTab(LIVE_GAME_TAB);
          } else {
            setTab(CREATE_GAME_TAB);
          }
        }
      }
    }

    chooseGame({
      time,
      inc,
      variant,
      modeId: getModeId(time, variant, timeControl),
      turnLength,
      timeControl,
    });
  } catch (e) {
    chooseGame({
      time: 10,
      inc: 0,
      variant: VARIANT_CHESS,
      modeId: ModeIds.RAPID,
      timeControl: TimeControl.LIVE,
      turnLength: 2,
    });
  }
}

async function initPlayWire(isDesktop) {
  const pwUnits = [];

  if (isDesktop) {
    pwUnits.push({
      selectorId: "lobby_skyscraper_right",
      type: "sky_atf",
    });
  } else {
    pwUnits.push({
      selectorId: "lobby_bottom",
      type: "leaderboard_atf",
    });
  }

  if (typeof window.ramp?.spaAds === "function") {
    try {
      await window.ramp.spaAds({
        ads: pwUnits,
        countPageview: shouldCountPlaywirePageview(),
        path: "ROS",
      });
    } catch (error) {
      console.log(error);
    }
  }
}

const GAM_SIZE_DESKTOP = [[160, 600]];
const GAM_SIZE_MOBILE = [[320, 100]];

let GAM_SLOT_DESKTOP = "/22528994871/ch_lobby_right_rail";
let GAM_SLOT_MOBILE = "/22528994871/ch_lobby_mobile_bottom";
let GAM_ID_DESKTOP = "div-ch_lobby_right_rail";
let GAM_ID_MOBILE = "div-ch_lobby_mobile_bottom";

function initGAM(slotRef: any, isDesktop: boolean) {
  if (!window.googletag?.cmd) return;

  let GAM_SLOT = GAM_SLOT_MOBILE;
  let GAM_ID = GAM_ID_MOBILE;
  let GAM_SIZE = GAM_SIZE_MOBILE;

  if (isDesktop) {
    GAM_SLOT = GAM_SLOT_DESKTOP;
    GAM_ID = GAM_ID_DESKTOP;
    GAM_SIZE = GAM_SIZE_DESKTOP;
  }

  window.googletag.cmd.push(() => {
    const slot = window.googletag
      .defineSlot(GAM_SLOT, GAM_SIZE, GAM_ID)
      ?.addService(window.googletag.pubads());

    if (!slot) return;
    slotRef.current = slot;

    window.googletag.display(GAM_ID);
  });
}

function initYandex(isDesktop) {
  // window.yaContextCb.push(() => {
  //   window.Ya.Context.AdvManager.render({
  //     renderTo: "yandex_rtb_R-A-1674804-8",
  //     blockId: "R-A-1674804-8",
  //   });
  // });

  if (isDesktop) {
    window.yaContextCb.push(() => {
      window.Ya.Context.AdvManager.render({
        renderTo: "yandex_rtb_R-A-1674804-5",
        blockId: "R-A-1674804-5",
      });
    });
  } else {
    window.yaContextCb.push(() => {
      window.Ya.Context.AdvManager.render({
        renderTo: "yandex_rtb_R-A-1674804-9",
        blockId: "R-A-1674804-7",
      });
    });
  }
}

function preloadStockfish() {
  const preloadQuick = async () => {
    // Preload the Stockfish worker early so end-of-game quick pass is instant
    try {
      const mod = await import("@/modules/gameReview/stockfishPool");
      // Preload only a single worker on first load; GameReviewStart will expand the pool.
      await mod.initStockfishPool(true, 1, true);
    } catch (e) { }
    // Optionally also preload the quick client review module
    try {
      await import("@/modules/gameReview/quickClientReview");
    } catch (e) { }
  };
  if ("requestIdleCallback" in window) {
    window.requestIdleCallback(preloadQuick);
  } else {
    setTimeout(preloadQuick, 5000);
  }
}
/**
 * Checks if user is a returning visitor by looking for saved game settings.
 * First-time visitors get the new chess set by default.
 * Returning visitors who haven't seen the popup will see it.
 */
function checkChessSetForUser(): { showPopup: boolean } {
  const hasSeenPopup = localStorage.getItem("chessSetPopupSeen") === "true";
  if (hasSeenPopup) {
    return { showPopup: false };
  }

  // Check if user has any saved game settings (indicating they're a returning user)
  const savedSettings = [
    "chosenTime",
    "chosenInc",
    "chosenVariant",
    "turnLength",
    "timeControl",
  ];
  const isReturningUser = savedSettings.some(
    (key) => localStorage.getItem(key) !== null
  );

  const currentChessSet = localStorage.getItem("chessSet");
  if (currentChessSet === ChessSets.STAUNTY) {
    return { showPopup: false };
  }

  if (isReturningUser) {
    // Returning user who hasn't seen popup - show it

    return { showPopup: true };
  } else {
    // First-time visitor - set new chess set as default
    setSetting({ name: "chessSet", val: ChessSets.CHESSHOTEL_NEW });
    localStorage.setItem("chessSetPopupSeen", "true");
    return { showPopup: false };
  }
}

export default function Lobby() {
  const { t } = useTranslation("common");

  const { customGamePopupVisible, challengePopupVisible, tab } = useLobby();
  const { adsVisible, adsProvider } = useSiteData();
  const { tier } = useMembership();
  // const { loading } = useSignIn();
  // const { wsConnected } = useWsConnection();
  // const { memberLoggedIn } = useUser();
  const { chessSet, isDesktop } = useSettings();
  const [showChessSetPopup, setShowChessSetPopup] = useState(false);

  const router = useRouter();

  const slotRef = useRef<any | null>(null);

  // One-time initialization on mount
  useEffect(() => {
    router.prefetch("/game");
    initLobbyChosenGame(isDesktop, tab);
    window.scrollTo(0, 0);
    enterLobby();

    // Check if we need to show the chess set selection popup
    const { showPopup } = checkChessSetForUser();
    setShowChessSetPopup(showPopup);
  }, []);

  // Preload assets when settings are available
  useEffect(() => {
    if (chessSet) {
      preloadChessImages(chessSet);
    }
    if (isDesktop) {
      preloadStockfish();
    }
  }, [chessSet, isDesktop]);

  useEffect(() => {
    if (
      !adsVisible ||
      isDesktop === null ||
      tier === REGULAR_TIER ||
      tier === UNLIMITED_TIER
    ) {
      return;
    }

    if (adsProvider === ADS_PROVIDER_PLAYWIRE) {
      initPlayWire(isDesktop);
    } else if (adsProvider === ADS_PROVIDER_YANDEX) {
      initYandex(isDesktop);
    } else if (adsProvider === ADS_PROVIDER_GAM) {
      initGAM(slotRef, isDesktop);
    }

    return () => {
      if (!window.googletag?.cmd || !slotRef.current) return;

      window.googletag.cmd.push(() => {
        window.googletag.destroySlots([slotRef.current]);
      });

      slotRef.current = null;
    };
  }, [adsVisible, adsProvider, tier, isDesktop]);

  function renderSideAdRight() {
    if (tier === REGULAR_TIER || tier === UNLIMITED_TIER) {
      return null;
    }

    switch (adsProvider) {
      case ADS_PROVIDER_PLAYWIRE:
        return (
          <div
            id="lobby_skyscraper_right"
            className="flex flex-col md:w-[160px] h-[600px]"
          // contStyles="h-[600px]"
          />
        );

      case ADS_PROVIDER_ADSENSE:
        return (
          <AdSense
            adStyles={styles.sideAd}
            showRemoveAds={false}
            slot="3442544075"
            format="auto"
            insStyle={{ width: "100%" }}
          />
        );

      case ADS_PROVIDER_YANDEX:
        return (
          <div
            className="flex flex-col md:w-[160px] h-[600px]"
            id="yandex_rtb_R-A-1674804-5"
          ></div>
        );

      case ADS_PROVIDER_GAM:
        return (
          <div
            id={GAM_ID_DESKTOP}
            className="flex flex-col md:w-[160px] h-[600px]"
          >
            {/* DIY ad slot - implement your ad solution here */}
          </div>
        );

      default:
        return null;
    }
  }

  function renderFooterAd() {
    if (tier === REGULAR_TIER || tier === UNLIMITED_TIER) {
      return null;
    }

    switch (adsProvider) {
      case ADS_PROVIDER_PLAYWIRE:
        return <PlayWire id="lobby_bottom" className={styles.footerAd} />;

      case ADS_PROVIDER_ADSENSE:
        return (
          <AdSense
            adStyles={styles.footerAd}
            showRemoveAds={false}
            slot="6991788029"
            format="auto"
            insStyle={{ width: "100%", height: "120px" }}
          />
        );
      case ADS_PROVIDER_YANDEX:
        return (
          <div className={styles.footerAd} id="yandex_rtb_R-A-1674804-9"></div>
        );

      case ADS_PROVIDER_GAM:
        return (
          <div className={styles.footerAd} id={GAM_ID_MOBILE}>
            {/* DIY ad slot - implement your ad solution here */}
          </div>
        );

      default:
        return <div className={styles.footerAd}></div>;
    }
  }

  return (
    <>
      <Head>
        <title>Chess Hotel | Lobby</title>
        <meta name="description" content={t("description")} />
        <meta name="keywords" content={t("keywords")} />
      </Head>
      {customGamePopupVisible && <CustomGamePopup />}
      {challengePopupVisible && (
        <ChallengePopup
          onClose={() => showChallengePopup(false)}
          friend={null}
        />
      )}
      {showChessSetPopup && (
        <ChessSetPopup onClose={() => setShowChessSetPopup(false)} />
      )}
      <LobbyPopups />
      <div className="flex w-full">
        <div className="flex justify-center px-1 pb-4 w-full shrink md:px-2">
          <div className="flex flex-col w-full max-w-[1000px] px-2 md:px-0">
            <LobbyHead />
            <div className="flex flex-col mb-3 w-full md:flex-row md:justify-center md:mb-4">
              <div className="flex flex-col rounded-t-xl rounded-b-md shrink basis-7/12">
                <LobbyBody isDesktop={isDesktop} />
              </div>
              <div className="hidden relative flex-col w-full md:flex md:basis-5/12 md:shrink-0 md:ml-4">
                <CreateGame isDesktop={isDesktop} />
              </div>
            </div>
            {!isDesktop && renderFooterAd()}
          </div>
        </div>
        {tier !== REGULAR_TIER && tier !== UNLIMITED_TIER ? (
          <div className="hidden md:flex shrink-0 transition-none md:w-[184px] p-3 h-[666px] bg-gray-200">
            {isDesktop && renderSideAdRight()}
          </div>
        ) : (
          <div className="hidden w-0 bg-gray-200 transition-all duration-500 md:flex"></div>
        )}
      </div>
      {/* Force CSS background image loading - uses inline styles to match Piece.tsx */}
      <div
        style={{
          position: "absolute",
          visibility: "hidden",
          width: 0,
          height: 0,
          overflow: "hidden",
        }}
      >
        {/* Preload board background */}
        <div className={boardStyles[chessSet]}></div>
        {/* Preload all piece images using inline styles (matches Piece.tsx) */}
        {getPieceImageUrls(chessSet).map((url) => (
          <div
            key={url}
            style={{
              width: 1,
              height: 1,
              backgroundImage: `url(${url})`,
              backgroundSize: "contain",
            }}
          />
        ))}
      </div>
    </>
  );
}
